// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__DhnDa","header":"ClearentDisclaimer_header__kCqck","inner":"ClearentDisclaimer_inner__3AtAM"};